import React, { useContext } from 'react'

import { IAwesomeBarContext } from '../types'

export const AwesomeBarContext = React.createContext({} as IAwesomeBarContext)

export const useAwesomeBarContext = () => {
  return useContext(AwesomeBarContext)
}
